import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";

import img_icon_red_warning from "@/Globals/_images/icons/red-warning.png";

interface IHighPriorityIndicatorProps {
    style?: React.CSSProperties;
    imgStyle?: React.CSSProperties;
}

class HighPriorityIndicator extends BaseReactComponent<IHighPriorityIndicatorProps> {
    public render(): JSX.Element {
        return (
            <span style={this.props.style}>
                <img style={this.props.imgStyle} src={img_icon_red_warning} />
            </span>
        );
    }
}

export { HighPriorityIndicator };
